import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { motion, AnimatePresence } from 'framer-motion';
import "./SuccessPage.css";

const SuccessPage = () => {
  const [showCheck, setShowCheck] = useState(true);
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowCheck(false);
      setTimeout(() => setShowLogo(true), 500); // Petit délai avant d'afficher le logo
    }, 1500);
  }, []);

  return (
    <div className="success-container">
      <Confetti />

      <div className="card">
        {/* Check animation */}
        <AnimatePresence>
          {showCheck && (
            <motion.div
              className="check-circle"
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 1.2, opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <svg
                className="check-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" stroke="currentColor" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Logo FE animation */}
        <AnimatePresence>
          {showLogo && (
            <motion.img
              className="icon fe"
              src="https://res.cloudinary.com/vimplay/image/upload/v1743184210/fe_cdn/fe_logo_txv8hm.svg"
              alt=""
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            />
          )}
        </AnimatePresence>

        <h1 className="title">Paiement réussi!</h1>
        <p className="message">Merci pour votre achat.</p>
        <div className="info-box">
          <p className="info">
            Votre <span className="bold">E-Book</span> a été ajouté à votre compte avec succès. Suivez les instructions ci-dessous pour vérifier le status d'achat.
          </p>
        </div>
        <div className="contact">
          <p className="ct">Vous avez des questions? Contactez-nous</p>
          <a href="mailto:freelancediteur@gmail.com" className="email">
            freelancediteur@gmail.com
          </a>
        </div>
        <div className="return-btn">
          <p className="button" >Retournez dans l'application sans la fermée</p>
            {/*<a href="freelancediteur://ebook_app/profile" className="button">
              Retour à l'application
            </a>*/}
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
